module.exports = __webpack_public_path__ + "static/media/heal.f89cc491.wav";